import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import * as Icon from '../../Imports/Icons';
import Axios from '../../Imports/Axios';
import { v4 as uuidv4 } from 'uuid';
import Hidden from '@material-ui/core/Hidden';
import * as Storage from '../../Imports/Storage';

//const socket = io.connect('/loginSocket', {query: `saadKey=${saadKey}`})

const useStyles = theme => ({
  root: {
    padding: '0 10% 0 10%',
    margin: 0,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    textAlign: 'center',
    width: '100%',
    direction: 'rtl',
    '& h3': {
      color: '#51bb25',
      fontSize: 25,
      textAlign: 'right',
      marginBottom: 5
    },
    '& h1': {
      color: '#333',
      fontSize: 17,
      marginBottom: 60,
      textAlign: 'right'
    }
  },
  rtl: {
    direction: 'rtl'
  },
  inputWraper: {
    width: '100%'
  },
  iconField: {
    color: 'rgba(0,0,0,0.5)',
    fontSize: 30,
    padding: 2
  },
  fieldWraper: {
    marginBottom: 20
  },
  input: {
    width: '95%',
    '& input': {
      color: 'rgba(0,0,0,0.8)',
      padding: 5,
      height: 40
    },
    '& label': {
      fontFamily: 'Vazir',
      color: 'rgba(0,0,0,0.5)',
      top: 5,
      fontSize: 15
    },
    '& label.Mui-focused': {
      color: 'rgba(0,0,0,0.8)'
    },
    '& .MuiInput-underline:before': {
      borderBottom: '#dee2ea solid 2px'
    },
    '& .MuiInput-underline:after': {
      borderBottom: '#b3c6ff solid 2px'
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '#dee2ea solid 2px'
    }
  },
  loginButton: {
    background: '#0068ff',
    color: '#fff',
    width: '100%',
    borderRadius: 2,
    marginTop: 20,
    fontFamily: 'Vazir',
    fontSize: 17,
    '&:hover': {
      background: '#003df2'
    }
  },
  backdrop: {
    zIndex: 10000,
    color: '#fff'
  }
});
class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertSeverity: '',
      alertMessage: '',
      openBackdrop: false,
      openSnackbar: false,
      saadKey: null
    };
  }
  async componentDidMount() {
    let sessionId = await Storage.get('sessionId');
    if (!sessionId) {
      const uuid = uuidv4();
      await Storage.set('sessionId', uuid);
      sessionId = uuid;
    }
  }
  async LoginToSaad(event) {
    event.preventDefault();
    this.setState({
      openBackdrop: true
    });
    const loginData = {
      username: document.getElementById('username').value,
      password: document.getElementById('password').value
    };
    const requestOptions = {
      url: 'users/login',
      method: 'POST',
      withCredentials: true,
      data: loginData
    };
    try {
      const response = await Axios(requestOptions);
      if (response.data.status === 1000) {
        await Storage.set('loggedInUser', {
          userId: response.data.data.userId,
          name: response.data.data.user,
          picture: response.data.data.picture,
          cover: response.data.data.cover,
          organizationLevels: response.data.data.organizationLevels,
          currentOrganization: response.data.data.currentOrganization
        });
        await Storage.set('accessToken', response.data.data.accessToken);
        await Storage.set('userOptions', response.data.data.options);
        setTimeout(() => {
          window.location = `/${uuidv4().replace(/-/g, '')}`;
        }, 3000);
      } else {
        this.setState({
          alertSeverity: 'error',
          alertMessage: response.data.message,
          openBackdrop: false,
          openSnackbar: true
        });
      }
    } catch (error) {
      console.log(error);
    }

    /* Axios.then( (axiosObj) => {
      axiosObj.request(requestOptions)
    .then(async response => {
      if(response.data.status === 1000) {
         const current = new Date()
        const nextYear = new Date()
        nextYear.setFullYear(current.getFullYear() + 1)
         await Storage.set('loggedInUser', {
          userId: response.data.data.userId,
          name: response.data.data.user,
          picture: response.data.data.picture,
          cover: response.data.data.cover,
          organizationLevels: response.data.data.organizationLevels,
          currentOrganization: response.data.data.currentOrganization
        })
        
         await Storage.set('userOptions', response.data.data.options)
        
        
        setTimeout(() => {
            window.location = `/${uuidv4().replace(/-/g, '')}`
        }, 2000)
      }
      else {
        this.setState({
          alertSeverity: 'error',
          alertMessage: response.data.message,
          openBackdrop: false,
          openSnackbar: true
        })
      }
    })
    .catch(err => {
      this.setState({
        alertSeverity: 'error',
        alertMessage: 'عدم دسترسی به سرور',
        openBackdrop: false,
        openSnackbar: true
      });
    })
    }) */
  }
  render() {
    const {
      classes
    } = this.props;
    const {
      openBackdrop,
      openSnackbar,
      alertMessage,
      alertSeverity
    } = this.state;
    return <div dir="rtl">
        <Hidden smUp>
        <div className='saad-logo'>
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="120.000000pt" height="43.000000pt" viewBox="0 0 1000.000000 356.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,356.000000) scale(0.100000,-0.100000)" fill="#0068ff" stroke="none">
              <path d="M6443 3233 c6 -367 14 -425 73 -568 42 -99 118 -223 196 -321 81
-101 343 -349 451 -427 21 -16 93 -74 160 -130 67 -56 178 -147 247 -202 69
-54 156 -124 193 -155 38 -30 78 -62 90 -71 l20 -17 -22 -53 c-125 -296 -257
-480 -444 -618 -143 -105 -285 -137 -406 -91 -102 38 -96 13 -99 398 -3 244
-7 339 -15 344 -15 9 -321 10 -394 2 l-53 -7 0 -658 0 -659 323 0 c361 0 465
10 614 59 367 120 665 449 863 953 46 115 149 417 179 523 6 22 19 57 29 78
l17 37 115 -92 c206 -165 629 -530 696 -600 96 -99 174 -238 174 -310 0 -33
-28 -75 -54 -82 -13 -3 -163 -6 -332 -6 -169 0 -309 -1 -311 -4 -2 -2 -17 -37
-33 -77 -61 -158 -105 -248 -176 -356 -41 -61 -74 -114 -74 -117 0 -3 344 -6
765 -6 l765 0 0 328 c0 399 -6 430 -113 647 -78 157 -165 266 -329 413 -56 49
-305 243 -408 317 -139 100 -496 381 -519 409 -17 20 6 86 99 281 89 188 180
323 289 428 117 113 195 152 301 152 112 -1 191 -43 237 -128 16 -28 18 -69
21 -349 l3 -317 47 -3 c26 -2 120 -2 210 0 l162 3 0 691 0 690 -292 -5 c-319
-6 -385 -14 -555 -68 -177 -57 -323 -147 -458 -283 -246 -248 -368 -494 -566
-1146 -21 -70 -93 -230 -104 -230 -2 0 -60 46 -127 103 -68 56 -137 114 -154
127 -182 146 -353 297 -480 425 -204 206 -291 398 -213 476 18 18 36 19 404
19 319 0 385 2 385 14 0 24 37 129 73 208 37 81 142 244 203 316 l37 42 -858
0 -858 0 6 -327z" />
              <path d="M4950 848 c0 -202 4 -338 11 -363 25 -93 92 -126 267 -133 144 -6
191 7 245 67 l34 38 28 -35 c54 -68 84 -74 358 -70 285 4 289 5 334 95 25 52
28 68 28 158 0 83 -4 107 -22 140 -29 54 -68 90 -127 116 -137 60 -280 -37
-389 -264 l-52 -108 -35 5 c-22 3 -45 17 -62 36 -27 29 -28 35 -28 135 l0 105
-65 0 -65 0 0 -105 c0 -164 -11 -175 -179 -175 -157 0 -145 -29 -149 361 l-3
319 -65 0 -64 0 0 -322z m1132 -119 c58 -31 64 -199 8 -229 -10 -6 -80 -10
-155 -10 l-136 0 27 50 c15 28 52 78 83 111 72 80 124 104 173 78z" />
              <path d="M973 1034 c-20 -20 -24 -31 -19 -57 9 -44 27 -58 78 -64 52 -6 85 16
94 64 9 46 -30 83 -86 83 -31 0 -47 -6 -67 -26z" />
              <path d="M1232 1044 c-16 -11 -22 -25 -22 -52 0 -43 7 -55 37 -71 59 -31 133
7 133 68 0 59 -93 94 -148 55z" />
              <path d="M4431 946 l-44 -45 95 -103 c235 -254 237 -257 202 -292 -13 -14 -50
-16 -245 -16 l-230 0 6 -47 c3 -27 8 -58 11 -70 l4 -23 226 0 c180 0 232 3
262 15 72 31 112 86 112 157 -1 84 -15 103 -339 451 -16 16 -19 15 -60 -27z" />
              <path d="M180 871 c-75 -23 -117 -61 -152 -136 -22 -48 -23 -61 -26 -383 l-4
-332 66 0 66 0 0 308 c0 272 2 311 18 341 21 42 56 69 100 77 l32 7 0 -109 c1
-119 12 -163 54 -219 57 -74 182 -105 268 -67 26 11 54 33 64 49 10 15 19 30
20 32 2 2 17 -13 34 -33 43 -48 78 -56 261 -56 145 0 159 2 204 24 l48 25 29
-22 c27 -20 42 -22 146 -22 139 0 177 7 227 41 l38 25 21 -20 c79 -74 206 -79
306 -12 l42 28 49 -33 c87 -58 182 -56 253 7 28 24 35 26 40 14 3 -9 25 -25
48 -35 37 -17 67 -20 214 -20 161 0 173 1 219 24 l48 25 29 -22 c26 -19 45
-22 160 -25 145 -4 185 5 247 56 l34 29 31 -30 c87 -82 182 -86 280 -12 31 23
34 24 47 9 23 -28 111 -64 156 -64 55 0 91 14 131 53 46 45 62 107 62 249 l0
118 -65 0 -65 0 0 -120 c0 -115 -1 -122 -25 -145 -46 -47 -144 -24 -171 40 -9
22 -14 70 -14 130 l0 95 -60 0 -60 0 0 -97 c0 -124 -12 -171 -48 -184 -45 -18
-103 -4 -134 31 -27 29 -28 34 -28 140 l0 110 -65 0 -65 0 0 -110 c0 -104 -1
-112 -25 -135 -22 -23 -31 -25 -124 -25 -55 0 -111 4 -125 10 -33 12 -46 61
-46 173 l0 87 -65 0 -65 0 0 -110 c0 -104 -1 -112 -25 -135 -23 -24 -29 -25
-172 -26 -190 -2 -194 -1 -220 24 -21 19 -23 29 -23 134 l0 113 -65 0 -65 0 0
-120 c0 -115 -1 -122 -25 -145 -30 -31 -86 -33 -132 -5 -40 24 -53 67 -53 183
l0 87 -65 0 -65 0 0 -123 c0 -144 -6 -157 -71 -164 -52 -5 -104 22 -119 63 -6
14 -10 70 -10 125 l0 99 -65 0 -65 0 0 -109 c0 -102 -2 -112 -24 -138 -24 -27
-27 -28 -121 -27 -80 1 -101 4 -123 21 -26 20 -27 23 -30 137 l-3 116 -69 0
-70 0 0 -114 c0 -112 -1 -115 -26 -135 -24 -19 -40 -21 -181 -21 l-155 0 -27
28 c-25 24 -28 37 -33 108 -6 82 -31 159 -66 198 -9 10 -35 27 -57 37 -34 16
-66 18 -225 18 -102 0 -196 -4 -210 -8z m350 -130 c65 -13 80 -37 80 -128 0
-70 -2 -76 -30 -105 -28 -27 -36 -30 -76 -25 -28 3 -55 13 -70 28 -23 21 -24
29 -24 131 l0 108 38 0 c20 -1 57 -5 82 -9z" />
              <path d="M2575 145 c-33 -32 -31 -60 4 -96 46 -46 110 -38 139 18 18 32 15 51
-13 78 -34 35 -96 35 -130 0z" />
              <path d="M2832 154 c-33 -23 -31 -86 4 -113 57 -45 144 -10 144 58 0 59 -93
94 -148 55z" />
            </g>
          </svg>
        </div>
        </Hidden>
      <form className={classes.root} dir="rtl" onSubmit={this.LoginToSaad.bind(this)}>
      <h3>خوش آمدید</h3>
      <h1>اتوماسیون گروه صنعتی MGH</h1>
      <p>همکار گرامی جهت انجام امور سازمانی و یا دریافت فیش حقوقی شرکت‌های غرب استیل و ماژین استیل به پنل کاربری خود وارد شوید</p>
      
        <Grid container spacing={1} alignItems="flex-end" className={classes.fieldWraper}>
          <Grid xs={1} item>
            <Icon.User className={classes.iconField} />
          </Grid>
          <Grid xs={11} item>
            <TextField label="نام کاربری" className={classes.input} id="username" />
          </Grid>
        </Grid>

        <Grid container spacing={1} alignItems="flex-end" className={classes.fieldWraper}>
          <Grid xs={1} item>
            <Icon.Password className={classes.iconField} />
          </Grid>
          <Grid xs={11} item>
            <TextField label="گذرواژه" type="password" className={classes.input} id="password" />
          </Grid>
        </Grid>

        <Button className={classes.loginButton} type="submit">ورود</Button>
        {false ? <a className='android' target='_blank' rel="noopener noreferrer" href='http://statics.saadsystem.ir/apk/saadsystem-mgh.apk' title='دانلود نسخه اندروید'>
          <img src='/images/android.png' alt='دانلود نسخه اندروید' />
        </a> : <></>}
      </form>
      <Backdrop className={classes.backdrop} id="mask" open={openBackdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar open={openSnackbar} onClose={() => this.setState({
        openSnackbar: false
      })} autoHideDuration={5000} anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}>
        <Alert id="alert" variant="filled" severity={alertSeverity} action={<Icon.Close aria-label="close" onClick={() => this.setState({
          openSnackbar: false
        })} color="inherit" />}>
          {alertMessage}
        </Alert>
      </Snackbar>
      </div>;
  }
}
export default withStyles(useStyles)(LoginForm);